import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import About from "../views/About";
import Contact from "../views/Contact";
import NewNote from "../views/notes/Create";
import TableOfNote from "../views/notes/Table";
import ShowTheNote from "../views/notes/Show";
import EditNote from "../views/notes/Edit";
import NewSubject from "../views/subjects/Create";
import TableOfSubject from "../views/subjects/Table";
import ShowTheSubject from "../views/subjects/Show";
import EditSubject from "../views/subjects/Edit";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
  },
  {
    path: "/about",
    name: "pages.about",
    component: About,
  },
  {
    path: "/contact",
    name: "pages.contact",
    component: Contact,
  },
  {
    path: "/notes/create",
    name: "notes.create",
    component: NewNote,
  },
  {
    path: "/notes/table",
    name: "notes.table",
    component: TableOfNote,
  },
  {
    path: "/notes/:noteSlug",
    name: "notes.show",
    component: ShowTheNote,
  },
  {
    path: "/notes/:noteSlug/edit",
    name: "notes.edit",
    component: EditNote,
  },
  {
    path: "/subjects/create",
    name: "subjects.create",
    component: NewSubject,
  },
  {
    path: "/subjects/table",
    name: "subjects.table",
    component: TableOfSubject,
  },
  {
    path: "/subjects/:id",
    name: "subjects.show",
    component: ShowTheSubject,
  },
  {
    path: "/subjects/:id/edit",
    name: "subjects.edit",
    component: EditSubject,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
